import { render, staticRenderFns } from "./ImageViewer.vue?vue&type=template&id=0a2360de&scoped=true&"
import script from "./ImageViewer.vue?vue&type=script&lang=js&"
export * from "./ImageViewer.vue?vue&type=script&lang=js&"
import style0 from "./ImageViewer.vue?vue&type=style&index=0&id=0a2360de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2360de",
  null
  
)

export default component.exports